<template>
  <div class="modal sign-modal contact-modal">
    <div class="overlay" @click="$parent.closeContactUs" />
    <div class="wrapper">
      <div class="container">
        <div class="form">
          <div class="form-wrapper">
            <button class="close" @click="$parent.closeContactUs">
              <div class="desc smallest">{{ $t("Close") }}</div>
              <img class="img" src="./../img/close.svg" />
            </button>

            <div class="left">
              <div class="top-text">
                <div class="title big title-main">{{ $t("Contact Us") }}</div>
              </div>
              <div class="bottom-text">
                <!-- <div class="desc smallest">Admin Email:</div>
                <a
                  :href="'mailto:' + $parent.settings.support_email"
                  class="desc small blue link"
                >
                  <b>{{ $parent.settings.support_email }}</b></a
                > -->
                <img class="traveler" src="./../img/traveler2.webp" />
              </div>
            </div>
            <div class="right">
              <div class="form-fields">
                <div class="form-fields-wrapper">
                  <label>
                    <div class="desc">{{ $t("Full Name:") }}</div>
                    <input
                      v-model="name"
                      type="text" @input="filterInput($event, 'name')"
                      :placeholder="$t('Name')"
                    />
                  </label>
                  <label>
                    <div class="desc">{{ $t("E-mail:") }}</div>
                    <input
                      v-model="email"
                      type="email" @input="filterInput($event, 'email')"
                      :placeholder="$t('Email')"
                    />
                  </label>
                  <label>
                    <div class="desc">{{ $t("Leave your message here:") }}</div>
                    <textarea
                      v-model="message"
                      type="text" @input="filterInput($event, 'message')"
                      :placeholder="$t('Message')"
                    ></textarea>
                  </label>
                  <div class="cta-container">
                    <button class="button blue small" @click="submitContact">
                      <span>{{ $t("Send") }}</span>
                    </button>
                  </div>
                  <transition name="fade">
                    <div v-if="$parent.successMessage" class="desc green">
                      {{ $parent.successMessage }}
                    </div>
                  </transition>
                  <transition name="slide">
                    <div v-if="$parent.error" class="error-desc desc red">
                      {{ $parent.error }}
                    </div>
                  </transition>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "Login",
  props: [],
  data: function () {
    return {
      email: "",
      name: "",
      message: "",
    };
  },
  mounted() {},
  methods: {
    filterInput(e, field) {
      let value = e.target.value;
      value = value.replace(/[^a-zA-Z0-9\s'-]/g, '');
      value = value.replace(/\s+/g, ' ').trimStart();
      this[field] = value;
    },
    submitContact() {
      let contactData = {
        name: this.name,
        email: this.email,
        message: this.message,
      };
      this.$emit("sendContactForm", contactData);
    },
  },
};
</script>
